// ==========================================
// REPRESENTATION CATEGORY CONFIGURATION
// ==========================================
// UI metadata and utilities for representation categories.

import { RepresentationCategory, RepresentationCategoryInfo } from '../ontology.model';

export const REPRESENTATION_CATEGORIES: RepresentationCategoryInfo[] = [
  {
    name: RepresentationCategory.Value,
    description: 'A concrete number',
    topics: 'Real Number, Complex Number, Fraction',
    types: ['number', 'integer', 'natural', 'real', 'complex'],
    example: '$x = 34500$',
    svgPath: 'M 2 5 L 14 5 M 2 11 L 14 11 M 5.5 2 L 4.5 14 M 11.5 2 L 10.5 14',
  },
  {
    name: RepresentationCategory.Form,
    description: 'A specific notation of a value',
    topics: 'Standard Form, Surd, Index Form',
    types: ['string', 'latex', 'fraction', 'percentage'],
    example: '$3.45 \\times 10^4 = 34500$',
    svgPath: 'M 2 14 L 5 14 L 13 6 L 10 3 L 2 11 Z M 9 4 L 12 7',
  },
  {
    name: RepresentationCategory.Expression,
    description: 'An unevaluated algebraic structure',
    topics: 'Polynomial, Rational Expression',
    types: ['string', 'latex', 'symbolic'],
    example: '$2x^2 + 3x - 5$',
    svgPath: 'M 4 13 L 8 3 L 12 13 M 5.5 10 L 10.5 10',
  },
  {
    name: RepresentationCategory.Object,
    description: 'A geometric or abstract entity',
    topics: 'Point, Line, Vector, Matrix, Set',
    types: ['object', 'array', 'tuple'],
    example: '$\\vec{v} = (3, 4)$',
    svgPath:
      'M 5 2 C 3 2 3 3 3 5 L 3 6 C 3 7 2 8 1 8 C 2 8 3 9 3 10 L 3 11 C 3 13 3 14 5 14 M 11 2 C 13 2 13 3 13 5 L 13 6 C 13 7 14 8 15 8 C 14 8 13 9 13 10 L 13 11 C 13 13 13 14 11 14',
  },
  {
    name: RepresentationCategory.Function,
    description: 'A mapping from input to output',
    topics: 'Linear, Quadratic, Trigonometric',
    types: ['string', 'latex', 'callable'],
    example: '$f(x) = 2x + 3$',
    svgPath: 'M 2 8 Q 5 2 8 8 Q 11 14 14 8',
  },
  {
    name: RepresentationCategory.State,
    description: 'A logical classification',
    topics: 'Convergent/Divergent, Increasing',
    types: ['enum', 'boolean', 'string'],
    example: '$|r| < 1 \\Rightarrow$ CONVERGENT',
    svgPath: 'M 2 8 L 6 8 M 6 4 L 6 12 M 10 4 L 10 12 M 10 8 L 14 8',
  },
];

export function getRepresentationCategoryInfo(
  category: RepresentationCategory,
): RepresentationCategoryInfo | undefined {
  return REPRESENTATION_CATEGORIES.find((c) => c.name === category);
}

export function getRepresentationCategorySvgPath(category: RepresentationCategory | undefined): string {
  if (!category) {
    return '';
  }
  return getRepresentationCategoryInfo(category)?.svgPath ?? '';
}
